<template>
  <div class="messages_box" ref="messagesBox"
    @scroll="$emit('scroll', $event)">
    <div class="messages_list">
      <div class="extra_space"></div>
      <ul v-if="messages.length">
        <template v-for="(message, index) in messages">
          <ChatDateSeparator v-if="shouldShowDate(index)" :key="'date-' + getMessageKey(message, index)"
            :label="formatDate(message.timestamp)" />

          <ChatMessageItem :key="'message-' + getMessageKey(message, index)" :message="message"
            :selected-room-info="selectedRoomInfo" :self-user-id="selfUserId"
            :multi-message-option-enabled="multiMessageOptionEnabled" :selected-messages="selectedMessages"
            @reply="$emit('reply', $event)" @forward="$emit('forward', $event)" @delete="$emit('delete', $event)"
            @selection-change="$emit('selection-change', $event)" @replyMessageFullPreview="$emit('replyMessageFullPreview', $event)" />
        </template>
      </ul>

      <!-- <div v-else-if="!msgApiLoader" class="chat-empty-state">
          No messages yet.
        </div> -->

      <div class="typing_dots_wrp"  v-if="showTypingIndicator">
        <img src="@/assets/images/loading_dots.gif" height="30" alt="Typing">
      </div>

      <div class="msg_loader" v-if="msgApiLoader">
        <div class="spinner spinner-1" />
      </div>
    </div>
  </div>
</template>

<script>
import ChatDateSeparator from './ChatDateSeparator.vue';
import ChatMessageItem from './ChatMessageItem.vue';

export default {
  name: 'ChatMessageList',

  components: {
    ChatDateSeparator,
    ChatMessageItem
  },

  props: {
    selectedRoomInfo: {
      type: Object,
      default: null
    },

    messages: {
      type: Array,
      default: function () {
        return [];
      }
    },

    selfUserId: {
      type: [String, Number],
      required: true
    },

    typingUserInfoState: {
      type: Object,
      default: null
    },

    msgApiLoader: {
      type: Boolean,
      default: false
    },

    multiMessageOptionEnabled: {
      type: Boolean,
      default: false
    },

    selectedMessages: {
      type: Array,
      default: function () {
        return [];
      }
    },

  },

  computed: {
    showTypingIndicator() {
      return Boolean(
        this.typingUserInfoState &&
        this.selectedRoomInfo &&
        String(this.typingUserInfoState.ChatRoomId) ===
        String(this.selectedRoomInfo.chat_room)
      );
    }
  },

  methods: {
    getValidDate(timestamp) {
      if (!timestamp) {
        return null;
      }

      var date = new Date(timestamp);

      return isNaN(date.getTime()) ? null : date;
    },

    getDateKey(timestamp) {
      var date = this.getValidDate(timestamp);

      if (!date) {
        return '';
      }

      return [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
      ].join('-');
    },

    formatDate(timestamp) {

      var date = this.getValidDate(timestamp);

      if (!date) {
        return '';
      }

      var today = new Date();
      var yesterday = new Date();

      yesterday.setDate(today.getDate() - 1);

      var messageDateKey = this.getDateKey(timestamp);
      var todayDateKey = this.getDateKey(today);
      var yesterdayDateKey = this.getDateKey(yesterday);

      if (messageDateKey === todayDateKey) {
        return 'Today';
      }

      if (messageDateKey === yesterdayDateKey) {
        return 'Yesterday';
      }

      return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric'
      });
    },

    shouldShowDate(index) {
      if (index === 0) {
        return true;
      }

      var currentMessage = this.messages[index];
      var previousMessage = this.messages[index - 1];

      return (
        this.getDateKey(currentMessage.timestamp) !==
        this.getDateKey(previousMessage.timestamp)
      );
    },

    getMessageKey(message, index) {
      return message.id || message.message_id || index;
    },

    scrollToBottom() {
      this.$nextTick(function () {
        var container = this.$refs.messagesBox;

        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.messages_box {
  height: calc(100dvh - 236px);
  width: 100%;
  background: none;
  position: relative;
  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 6px;
    background: #000000;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #232323;
    border-radius: 10px;
  }

  .msg_loader {
    position: absolute;
    top: 0;
    width: 150px;
    height: 70px;
    left: 0;
    right: 0;
    margin: 0 auto;
    background: #000000;
    z-index: 100;

    .spinner {
      width: 65px;
      height: 65px;
      margin: 0px auto;

      &::after {
        width: 35px;
        height: 35px;
      }

      &::before {
        width: 65px;
        height: 65px;
      }
    }
  }

  .messages_list {
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 5px 35px;

    .extra_space {
      -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
      flex: 1 1 auto;
    }

    @media only screen and (max-width: 767px) {
      padding: 5px 25px;
    }

    &>ul {
      width: 100%;
      float: left;
      padding: 0px;
      margin: 0px;
      // display: flex;
      // flex-wrap: wrap-reverse;
    }
  }
}
</style>
